export const locales = ['fr', 'en'] as const

export type Locale = (typeof locales)[number]

export const defaultLocale: Locale = 'fr'
export const localeCookieName = 'cocoon_locale'

export const isLocale = (value: string): value is Locale =>
	locales.includes(value as Locale)

export const getLocalizedPath = (pathname: string, locale: Locale) => {
	if (
		pathname.startsWith('#') ||
		pathname.startsWith('?') ||
		pathname.startsWith('//') ||
		/^[a-z][a-z\d+.-]*:/i.test(pathname)
	) {
		return pathname
	}

	const normalizedPath = pathname.startsWith('/') ? pathname : `/${pathname}`
	const pathWithoutLocale = stripLocaleFromPath(normalizedPath)

	if (locale === defaultLocale) {
		return pathWithoutLocale
	}

	return pathWithoutLocale === '/'
		? `/${locale}`
		: `/${locale}${pathWithoutLocale}`
}

export const stripLocaleFromPath = (pathname: string) => {
	for (const locale of locales) {
		if (pathname === `/${locale}`) {
			return '/'
		}

		if (pathname.startsWith(`/${locale}/`)) {
			return pathname.slice(locale.length + 1)
		}
	}

	return pathname
}

export const getLocaleFromPath = (pathname: string): Locale => {
	for (const locale of locales) {
		if (locale === defaultLocale) continue

		if (pathname === `/${locale}` || pathname.startsWith(`/${locale}/`)) {
			return locale
		}
	}

	return defaultLocale
}
